import React from 'react';
import _ from 'lodash';

class SingleUnit extends React.Component {
  constructor() {
    super();

    this._updateComparedUnits = this._updateComparedUnits.bind(this);
  }

  render() {
    let selected = _.findIndex(this.props.comparedUnits, {assetid: this.props.data.assetid}) > -1,
      disabled = false,
      action = selected ? 'REMOVE' : 'SHORTLIST',
      classValue = selected ? 'button type-2 btn-remove' : 'button type-2 btn-select';

    if(this.props.isActive !== undefined && !this.props.isActive) {
      classValue = classValue + ' hidden';
    }

    let selectBtn = <form className="form-unit-select hidden" action="" method="POST">
        <input type="hidden" name="unit_assetid" value={this.props.data.assetid} />
        <input type="submit"
               className={disabled ? classValue + ' disabled' : classValue}
               value={action}
               disabled={disabled}
               onClick={this._updateComparedUnits} />
      </form>;

    return <li className={this.props.isActive ? 'clearfix is-active' : 'clearfix'}>
      <a href={this.props.data.URL}>
        <span className="unit-code__width">{this.props.data.UnitCode}</span>
        <strong>{this.props.data.name}</strong>
      </a>
      {selectBtn}
    </li>;
  }

  _updateComparedUnits(e) {
    e.preventDefault();
    let type, value;

    switch(e.target.value) {
    case 'SHORTLIST':
      type = 'UNIT_COMPARE::ADD';
      value = this.props.data;
      break;

    case 'REMOVE':
      type = 'UNIT_COMPARE::REMOVE';
      value = {
        assetid: this.props.data.assetid
      };
      break;
    }

    this.props.dispatchReducer({
      type: type, value
    });
  }
}

SingleUnit.propTypes = {
  data:            React.PropTypes.object.isRequired,
  comparedUnits:   React.PropTypes.array.isRequired,
  dispatchReducer: React.PropTypes.func.isRequired
};

export default SingleUnit;
